import React from 'react';
import { Switch, Route } from 'react-router-dom';

// Components
import EmailVerification from './EmailVerification';
import CustomerRegistration from './CustomerRegistration';

// Routes
export const routes = basePath =>
    <Switch>
        {<Route path={basePath + '/verification'} exact component={EmailVerification} />}
        {<Route path={basePath + '/registration'} exact component={CustomerRegistration} />}
    </Switch>
